export const I18n = {
	'en': {
		packSelect: 'Select a package',
		all: 'All'
	},
	'ru': {
		packSelect: 'Выбор пакета',
		all: 'Все'
	},
	'sk': {
		packSelect: 'Vyberte balíček',
		all: 'Všetko'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/packageSelect/index.js